import { Component, Input, ViewChild } from '@angular/core';
import { BaseModalComponent } from 'projects/libraries/syslink-components/src/lib/modal/base-modal/base-modal.component';
import { StockMoveOutgoingHeaderStatus } from '../../stock-move-outgoing-header-statuses/stock-move-outgoing-header-status.model';
import { SelectComponent } from 'projects/libraries/syslink-components/src/public-api';
import { FilterDescriptor } from 'devextreme/data';
import { StockMoveOutgoingHeaderStatusesService } from '../../stock-move-outgoing-header-statuses/stock-move-outgoing-header-statuses.service';

@Component({
  selector: 'app-stock-move-outgoing-status-select-modal',
  templateUrl: './stock-move-outgoing-status-select-modal.component.html',
  styleUrls: ['./stock-move-outgoing-status-select-modal.component.scss']
})
export class StockMoveOutgoingStatusSelectModalComponent extends BaseModalComponent<StockMoveOutgoingHeaderStatus>{
  @Input() public selectFilters: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public expand: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public title: string = "Select outgoing status";
  @Input() public content?: string;
  @Input() public data: any;
  @ViewChild('select') select?: SelectComponent;

  constructor(public stockMoveOutgoingHeaderStatusesService: StockMoveOutgoingHeaderStatusesService) {
    super();
  }

}